export default __webpack_public_path__ + "static/media/bridge_carousel.fc022d13.jpg";